export function getSubscriptionDurationLabel(label: string | number): string {
    if (Number(label) === 1) return `${label}\xa0miesiąc`;
    if (Number(label) <= 4) return `${label}\xa0miesiące`;
    return `${label}\xa0miesięcy`;
}
